import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Phone, MapPin, Linkedin } from 'lucide-react';

const LOGO_URL = '/solnity-icon.png';

const footerLinks = {
  Services: [
    { label: 'Global Staffing', path: '/global-staffing' },
    { label: 'IT Staffing', path: '/it-staffing' },
    { label: 'Our Process', path: '/our-process' },
  ],
  Partnership: [
    { label: 'Vendor Partnership', path: '/vendor-partnership' },
    { label: 'Hire Talent', path: '/hire-talent' },
    { label: 'Become a Vendor Partner', path: '/become-vendor-partner' },
  ],
  Candidates: [
    { label: 'Join Talent Pool', path: '/join-talent-pool' },
    { label: 'Candidate Profile Marketing', path: '/candidate-profile-marketing' },
  ],
  Company: [
    { label: 'About Us', path: '/about' },
    { label: 'Contact', path: '/contact' },
  ],
};

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] text-white">
      <div className="sol-container">
        {/* Main footer */}
        <div className="py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-0.5 mb-6">
              <img src={LOGO_URL} alt="Solnity" className="h-7 w-auto object-contain invert" />
              <span className="text-lg font-bold tracking-[0.04em]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Solnity
              </span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-6">
              Canada-based IT Staffing and Talent Solutions provider supporting clients across North America and the United Kingdom.
            </p>
            <div className="space-y-3">
              <a href="mailto:support@solnity.com" className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors">
                <Mail className="w-4 h-4 shrink-0" strokeWidth={1.5} />
                support@solnity.com
              </a>
              <a href="tel:2267998794" className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors">
                <Phone className="w-4 h-4 shrink-0" strokeWidth={1.5} />
                226-799-8794
              </a>
              <div className="flex items-start gap-2 text-sm text-white/60">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" strokeWidth={1.5} />
                <span>Scarborough,<br />Ontario, M1H 2M9, Canada</span>
              </div>
              <a href="https://ca.linkedin.com/company/solnity-services-limited" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors">
                <Linkedin className="w-4 h-4 shrink-0" strokeWidth={1.5} />
                LinkedIn
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4
                className="text-xs uppercase tracking-widest font-semibold text-white/40 mb-5"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      data-testid={`footer-link-${link.path.slice(1)}`}
                      className="text-sm text-white/70 hover:text-white transition-colors inline-flex items-center gap-1 group"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Canada Headquarters Badge */}
        <div data-testid="canada-hq-badge" className="border-t border-white/10 py-5">
          <div className="flex items-center justify-center gap-2">
            <MapPin className="w-4 h-4 text-white/50" strokeWidth={1.5} />
            <span className="text-xs font-semibold uppercase tracking-widest text-white/50" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Canada Headquarters &mdash; Scarborough, Ontario, Canada
            </span>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Solnity. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-white/40">Privacy Policy</span>
            <span className="text-xs text-white/40">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
